import { ObjectSchema, object, string } from "yup";

import { CreateIndexLinkedDocumentForm } from "@/pages/backoffice/backOfficeSubscriptionPage/indices/DocumentDetails";

export const createDocumentRequestSchema: ObjectSchema<CreateIndexLinkedDocumentForm> = object().shape({
  name: string().required("REQUIRED_FIELD"),
  extension: string().required("REQUIRED_FIELD"),
  url: string().required("REQUIRED_FIELD"),
});
